import React, { useCallback } from "react";
import { Typography } from "@mui/material";

import { colors } from "../../theme/palette";

import { CompareList } from "../../types";

import CompareRowText from "./CompareRowText";
import CompareRowFlag from "./CompareRowFlag";
import CompareRowBoolean from "./CompareRowBoolean";
import { useTranslation } from "react-i18next";

const CoachCompare = React.memo(({ compareUsersList }: { compareUsersList: any }) => {
  const { t } = useTranslation();

  const coachOverViewList: CompareList[] = [
    { label: t("components.compare.countriesCoachedIn"), key: "countriesWorkedIn", type: "flag" },
    { label: t("components.compare.coachType"), key: "coachType", type: "text" },
    { label: t("components.compare.teamsCoached"), key: "teamsCoached", type: "text" },
    { label: t("components.compare.trophiesWon"), key: "trophiesWon", type: "text" },
  ];

  const nationalityAndLocationList: CompareList[] = [
    { label: t("components.compare.nationality"), key: "nationality", type: "flag" },
    { label: t("components.compare.country"), key: "country", type: "flag" },
  ];

  const professionalInfoList: CompareList[] = [
    { label: t("components.compare.hasFootballExperience"), key: "hasFootballExperience", type: "boolean" },
    { label: t("components.compare.hasCertificate"), key: "hasCertificate", type: "boolean" },
  ];

  const skillsList: CompareList[] = [{ label: t("components.compare.skills"), key: "skills", type: "text" }];

  const preferredFormation: CompareList[] = [
    { label: t("components.compare.preferredFormation"), key: "preferredFormation", type: "text" },
  ];

  const renderCompareRow = useCallback((item: CompareList, index: number, list: CompareList[]) => {
    const { label, key, type } = item;
    const totalRows: number = list.length;
    const isLastRow: boolean = index + 1 === totalRows;

    switch (type) {
      case "text":
        return <CompareRowText compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "flag":
        return <CompareRowFlag compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "boolean":
        return (
          <CompareRowBoolean compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />
        );
      default:
        return null;
    }
  }, []);

  return (
    <>
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.coachOverview")}
      </Typography>
      {coachOverViewList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.nationalityAndLocation")}
      </Typography>
      {nationalityAndLocationList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.professionalInfo")}
      </Typography>
      {professionalInfoList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.skills")}
      </Typography>
      {skillsList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.preferredFormation")}
      </Typography>
      {preferredFormation.map(renderCompareRow)}
    </>
  );
});

export default CoachCompare;
